export const CAMPAIGN_BLOCKED_SHORTENER_DOMAINS = [
  'bit.ly',
  'tinyurl.com',
  'goo.gl',
  'ow.ly',
  't.co',
  'is.gd',
  'buff.ly',
  'shorturl.at',
  'tiny.cc',
  'rebrand.ly',
]

export const CAMPAIGN_BUSINESS_NAME_ERROR_MESSAGE = 'Business Name missing'

export const CAMPAIGN_URGENCY_MARKETING_PHRASES = [
  'FREE',
  'ACT NOW',
  'LIMITED TIME',
  'LAST CHANCE',
  'ENDS TODAY',
  'SAVE NOW',
  'SPECIAL OFFER',
  'EXCLUSIVE OFFER',
  'FLASH SALE',
  'SALE',
  'BONUS',
  'WIN',
  'WINNER',
  'YOU WON',
  'CLAIM NOW',
  'CONGRATULATIONS',
  'URGENT',
  '100% FREE',
]

export const CAMPAIGN_BUSINESS_NAME_START_CHARACTERS = 70
